import React from 'react';

import { HeaderToolbarLogin } from './HeaderToolbarLogin';
import { HeaderToolbarLogout } from './HeaderToolbarLogout';
import { HeaderToolbarAppSelector } from './HeaderToolbarAppSelector';
import type { AppDefinition } from '@klp/core/app/classes/AppDefinition';
import { HeaderMobileMenu } from './HeaderMobileMenu';
import { useLayoutContext } from '../../Layout';

export type HeaderToolbarProps = {
    appSelection: Array<AppDefinition>;
};
export const HeaderToolbar: React.FC<HeaderToolbarProps> = ({
    appSelection,
}) => {
    const { withoutSidebar } = useLayoutContext();
    return (
        <>
            <HeaderToolbarAppSelector appSelection={appSelection} />
            <HeaderToolbarLogin />
            <HeaderToolbarLogout />
            {!withoutSidebar && <HeaderMobileMenu />}
        </>
    );
};
